export default __webpack_public_path__ + "static/media/iconGoTo.676383b6.svg";